export default {
  "myaccount.yuzu.com" : "reader.yuzu.com"
}
